// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionWrapper_QRjBE {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}

.infoContainerWrapper_tR93d {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
}

.infoContainer_WdRqk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;

  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }

  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_CTS4_ {
  &.active_xYoBK {
    display: block;
  }

  &.disabled_Gwwdo {
    display: none;
  }
}

.contentInput_QGm67 {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_sHLZJ {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .optionsContentInput_sP_ba {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.cardTypesContainer_efBDc {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_aVtbT {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid #e0e3e6;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #2a2e32;
    -webkit-user-select: none;
            user-select: none;
  }
}

.minusIcon_yWp_3 {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
}


.subtitleContentInput_nsukt {
  font-weight: 300;
  font-size: 11;
  color: #18181b;
}

.quantityContainer_d7C32 {
  display: flex;
  gap: 10px;
  align-items: center;

  .quantityContent_L1sBm {
    gap: 10px;
    flex: 1 1;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    color: #1e0045;

    input {
      background-color: var(--f5-background);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      border-radius: 4px;
      padding: 0px 18px;
      font-family: "Inter", sans-serif;
      border: none;
      outline: none;
    }
  }

  p {
    margin: 0;
    height: fit-content;
  }
}

.currencyContainer_x5vrT {
  color: #264f88;
  font-weight: bold;
  border-bottom: 2px solid #264f88;
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;

  div {
    gap: 5px;
  }
}

.currencyDropdownButton_zw9vN {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

.chevronIcon_eAwDo {
  margin-top: 3px;
}

.currencyDropdown_nmlxq {
  position: absolute;
  top: 97%;
  left: -4%;
  width: 108%;
  display: flex;
  flex-direction: column;
  background-color: var(--f4-background);
  border-radius: 4px;
  color: #264f88;
  font-size: 14px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  z-index: 1;
  overflow: hidden;

  span {
    display: flex;
    padding: 1px 2px;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    justify-content: flex-start;

    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.conditionsContainer_qFfgz {
  display: flex;
  padding: 5px 9px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 23px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--f4-background);

  .conditions_F2s3C {
    display: flex;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;

    .condition_wffFS {
      display: flex;
      padding: 3px 12px;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      border: 1px solid #e0e3e6;
      background: var(--white-background);
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
      color: #2a2e32;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;  
    }
  }

  input {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    box-sizing: border-box;

    &::placeholder {
      color: var(--_71717a-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }
}

.labelName_YgLKg input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  border: 1px solid var(--d9-background);
  outline: none;
  color: #000000;
  margin: 15px 0;

  &::placeholder {
    color: #000000;
  }
}

.filtersLabelOptions_Os_Fk {
  border-left: 1px solid #c3c3c3;
  display: flex;
  padding-left: 22px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}

.buttonAddFilter_gKaQc {
  display: flex;
  height: 27px;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  background: var(--white-background);
  cursor: pointer;
}


.variableContainer_v70cr {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  cursor: pointer;
  height: 38px;
  border-radius: 4px;
  padding: 3px 10px;
  color: #868686
}

.variableContainer_v70cr:hover {
  background-color: var(--ececf1-background);
}

.searchEndpointInput_Fhzp9{
  width: 100%;
  box-sizing: border-box;
  border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    min-height: 45px !important;
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    padding: 8px;
    position: sticky;
    top: 0px;
}

.searchIconsWrappers_hVMzu {
  display: flex
  ;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      background: var(--ececf1-background);
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none;
      border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AutomateCreateOut/AutomateCreateOut.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;;EAEV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;;EAEzB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,SAAS;IACT,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;;IAEd;MACE,sCAAsC;MACtC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,gCAAgC;MAChC,YAAY;MACZ,aAAa;IACf;EACF;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;;EAEhB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;;IAE3B;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,eAAe;;IAEf;MACE,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,yBAAyB;MACzB,mCAAmC;MACnC,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;;IAEtB;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,cAAc;EACd,cAAc;;EAEd;IACE,cAAc;EAChB;AACF;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;IACV,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;EACE;EACA;MACI,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,oCAAoC;MACpC,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;AACxB","sourcesContent":[".sectionWrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n\n  &.disabled {\n    display: none;\n  }\n}\n\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid #e0e3e6;\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #2a2e32;\n    user-select: none;\n  }\n}\n\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.subtitleContentInput {\n  font-weight: 300;\n  font-size: 11;\n  color: #18181b;\n}\n\n.quantityContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  .quantityContent {\n    gap: 10px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    color: #1e0045;\n\n    input {\n      background-color: var(--f5-background);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 32px;\n      border-radius: 4px;\n      padding: 0px 18px;\n      font-family: \"Inter\", sans-serif;\n      border: none;\n      outline: none;\n    }\n  }\n\n  p {\n    margin: 0;\n    height: fit-content;\n  }\n}\n\n.currencyContainer {\n  color: #264f88;\n  font-weight: bold;\n  border-bottom: 2px solid #264f88;\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n\n  div {\n    gap: 5px;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n\n.chevronIcon {\n  margin-top: 3px;\n}\n\n.currencyDropdown {\n  position: absolute;\n  top: 97%;\n  left: -4%;\n  width: 108%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f4-background);\n  border-radius: 4px;\n  color: #264f88;\n  font-size: 14px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  z-index: 1;\n  overflow: hidden;\n\n  span {\n    display: flex;\n    padding: 1px 2px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    justify-content: flex-start;\n\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.conditionsContainer {\n  display: flex;\n  padding: 5px 9px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 23px;\n  align-self: stretch;\n  border-radius: 5px;\n  background: var(--f4-background);\n\n  .conditions {\n    display: flex;\n    width: 100%;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    .condition {\n      display: flex;\n      padding: 3px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 30px;\n      border: 1px solid #e0e3e6;\n      background: var(--white-background);\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n      color: #2a2e32;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;  \n    }\n  }\n\n  input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: var(--_71717a-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px;\n    }\n  }\n}\n\n.labelName input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  border: 1px solid var(--d9-background);\n  outline: none;\n  color: #000000;\n  margin: 15px 0;\n\n  &::placeholder {\n    color: #000000;\n  }\n}\n\n.filtersLabelOptions {\n  border-left: 1px solid #c3c3c3;\n  display: flex;\n  padding-left: 22px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.buttonAddFilter {\n  display: flex;\n  height: 27px;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  background: var(--white-background);\n  cursor: pointer;\n}\n\n\n.variableContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  cursor: pointer;\n  height: 38px;\n  border-radius: 4px;\n  padding: 3px 10px;\n  color: #868686\n}\n\n.variableContainer:hover {\n  background-color: var(--ececf1-background);\n}\n\n.searchEndpointInput{\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    min-height: 45px !important;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 8px;\n    position: sticky;\n    top: 0px;\n}\n\n.searchIconsWrappers {\n  display: flex\n  ;\n      align-items: center;\n      justify-content: center;\n      width: 18px;\n      height: 18px;\n      background: var(--ececf1-background);\n      cursor: pointer;\n      -webkit-user-select: none;\n      user-select: none;\n      border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionWrapper": `sectionWrapper_QRjBE`,
	"infoContainerWrapper": `infoContainerWrapper_tR93d`,
	"infoContainer": `infoContainer_WdRqk`,
	"contentContainer": `contentContainer_CTS4_`,
	"active": `active_xYoBK`,
	"disabled": `disabled_Gwwdo`,
	"contentInput": `contentInput_QGm67`,
	"titleContentInput": `titleContentInput_sHLZJ`,
	"optionsContentInput": `optionsContentInput_sP_ba`,
	"cardTypesContainer": `cardTypesContainer_efBDc`,
	"singleTypeCard": `singleTypeCard_aVtbT`,
	"minusIcon": `minusIcon_yWp_3`,
	"subtitleContentInput": `subtitleContentInput_nsukt`,
	"quantityContainer": `quantityContainer_d7C32`,
	"quantityContent": `quantityContent_L1sBm`,
	"currencyContainer": `currencyContainer_x5vrT`,
	"currencyDropdownButton": `currencyDropdownButton_zw9vN`,
	"chevronIcon": `chevronIcon_eAwDo`,
	"currencyDropdown": `currencyDropdown_nmlxq`,
	"conditionsContainer": `conditionsContainer_qFfgz`,
	"conditions": `conditions_F2s3C`,
	"condition": `condition_wffFS`,
	"labelName": `labelName_YgLKg`,
	"filtersLabelOptions": `filtersLabelOptions_Os_Fk`,
	"buttonAddFilter": `buttonAddFilter_gKaQc`,
	"variableContainer": `variableContainer_v70cr`,
	"searchEndpointInput": `searchEndpointInput_Fhzp9`,
	"searchIconsWrappers": `searchIconsWrappers_hVMzu`
};
export default ___CSS_LOADER_EXPORT___;
